module.exports = __webpack_public_path__ + "img/caring.534c9da3.png";